module.exports = __webpack_public_path__ + "img/list-bg.7b6ebb56.png";